import React from 'react'
import { EventTemplate } from '../../../models/Events/Events'
import { EventPage } from '../../cmsPageState'
import { AsyncState, Link } from 'widgets-for-react'
import i18next from 'i18next'

export interface EventDetailsProps {
  page?: number
  eventId: string | null
  pageData: EventPage
  eventData: AsyncState<EventTemplate>
}

export const ErrorBlock = () => {
  return <div>
    <div className="block block--specs">
      <div className="block__inner container--s gutter--m spacing--m">
        <div className="block__content">
          {i18next.t("errorBlock:blockErrorMessage")}
        </div>
      </div>
    </div>
  </div>
}

const GeneralInformationBlock = (props: EventDetailsProps) => {
  const { eventId } = props
  const { eventLocation, eventDate, eventTime, eventNonMemberPrice, eventMemberPrice, eventFormId, Bijeenkomst } = props.pageData
  return <div>
    <div className="block block--specs">
      <div className="block__inner container--s gutter--m spacing--m">
        <div className="block__content">
          <dl className="specs text--styled">
            <dt className="specs__term">Locatie:</dt>
            <dd className="specs__def">{eventLocation}</dd>

            <dt className="specs__term">Datum:</dt>
            <dd className="specs__def">
              {eventDate.toLocaleDateString("nl-nl")}
            </dd>

            <dt className="specs__term">Tijdstip:</dt>
            <dd className="specs__def">{eventTime}</dd>

            <dt className="specs__term">Prijs:</dt>
            <dd className="specs__def">{eventNonMemberPrice === 0 ? "Gratis"
              : eventNonMemberPrice === -1 ? "Op aanvraag"
                : eventNonMemberPrice === null ? "n.v.t."
                  : `${eventNonMemberPrice?.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })} ex. BTW`}</dd>

            <dt className="specs__term">Ledenprijs:</dt>
            <dd className="specs__def">
              <span style={{ paddingRight: '30px' }}>
                {eventMemberPrice === 0 ? "Gratis"
                  : eventMemberPrice === -1 ? "Op aanvraag"
                    : eventMemberPrice === null ? "n.v.t."
                      : `${eventMemberPrice?.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })} ex. BTW`}
              </span>
              <Link to="/lidmaatschap">{i18next.t('eventDetails:MoreInfoLink')}</Link>
            </dd>
          </dl>
        </div>

        <footer className="block__footer block__clickables">
          <div className="block__clickable">
            {Bijeenkomst?.RemoteId ?
              <Link
                to={`/evenementen/inschrijven?eventId=${eventId}`}
                className="button button--primary">
                <span className="button__label">
                  {i18next.t('eventDetails:SignUp')}
                </span>
              </Link>
              : eventFormId ?
                <Link to={`/formulieren/${eventFormId}`} className="button button--primary">
                <span className="button__label">{i18next.t('eventDetails:SignUp')}</span>
              </Link>
              : <></>
            }
          </div>
        </footer>
      </div>
    </div>
  </div>
}

export const EventDetailsBlockLayout = (props: EventDetailsProps) => {
  return (
    <div>
      {GeneralInformationBlock({ ...props })}
    </div>
  )
}
